import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AuthStore } from '@app/stores/auth.store';
import { ModalComponent } from '@app/ui-components/modal/modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-invest-done-dialog',
  standalone: true,
  imports: [CommonModule, ModalComponent, TranslatePipe],
  templateUrl: './invest-done-dialog.component.html',
  styleUrl: './invest-done-dialog.component.scss',
})
export class InvestDoneDialogComponent {
  activeModal = inject(NgbActiveModal);
  private authStore = inject(AuthStore);

  protected isQualified = this.authStore.isUserQualifiedInvestor;
}
